module.exports = __webpack_public_path__ + "static/img/cg-teaser-iPhone-e1.9022a01.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/CGdesign/src/assets/img/cg-teaser-iPhone-e1.png
// module id = NFYg
// module chunks = 1